import request from "../Config/axios";

// -----------------------------------------------------------
export const GetAll_FoodPrice_Api = async (foodPricePeriodId) => {
    const { data } = await request.get(
        `/FoodPrice/GetAll/?foodPricePeriodId=` + foodPricePeriodId,
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Active_FoodPrice_Api = async (foodPricePeriodId) => {
    const { data } = await request.get(
        `/FoodPrice/GetAll_Active/?foodPricePeriodId=` + foodPricePeriodId,
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_FoodPrice_Api = async (id) => {
    const { data } = await request.delete(
        `/FoodPrice/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const Add_FoodPrice_Api = async (params) => {
    const { data } = await request.post(
        `/FoodPrice/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Update_FoodPrice_Api = async (params) => {
    const { data } = await request.post(
        `/FoodPrice/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------